// extracted by css-extract-rspack-plugin
export default {"FinancialInfoReviewSection":"sputnik__FinancialInfoReviewSection__gXxON","financialInfoReviewSection":"sputnik__FinancialInfoReviewSection__gXxON"};